<script setup lang="ts">
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/onenetwork/stores/onenetwork.store.auth.ts'

const router = useRouter()
const AuthStore = useAuthStore()
onMounted(() => {
  const { path } = router.currentRoute.value

  if (path === '/') {
    if(AuthStore.user?.id){
      router.push('/dashboard/overview')
    }else{
      router.push('/auth/login')
    }
  }
})
</script>

<template>
  ...
</template>

<style scoped></style>
